module.exports = function() {
  return new Worker(__webpack_public_path__ + "b0c1572dff151c430d0b.worker.js");
};